export class VaultNotificationArguments {
    'id';
    'name';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
